// src/components/form/DynamicFormFields.tsx
import React from 'react';
import { Row, Col } from 'antd';
import { TextField } from './fields/TextField';
import { SelectField } from './fields/SelectField';
import { DynamicFormFieldsProps } from '../../types/formField.types';
import { CheckboxField } from './fields/CheckboxField';
import { TextareaField } from './fields/TextareaField';
import { RadioField } from './fields/RadioField';
import { DateField } from './fields/DateField';
import { SwitchField } from './fields/SwitchField';
import { PasswordField } from './fields/PasswordField';
import { NumberField } from './fields/NumberField';
import { FileUploadField } from './fields/FileUploadField';

export const DynamicFormFields: React.FC<DynamicFormFieldsProps> = ({ fields, mode }) => {
  const isView = mode === 'view';
  return (
    <Row gutter={24}>
      {fields
        .filter(field => !field.showOn || (mode && field.showOn.includes(mode))) // ✅ Only show field if mode matches or not defined
        .map(field => {
          const commonProps = {
            ...field,
            disabled: isView || field.disabled,
            mode,
          };

          // Dynamically set column attributes with defaults
          const colProps = {
            xs: field.xs || 24,
            sm: field.sm || 12,
            md: field.md || 12,
            lg: field.lg || 12,
            xl: field.xl || 12,
          };

          return (
            <Col {...colProps} key={field.name}>
              {field.type === 'text' && <TextField {...commonProps} />}
              {field.type === 'number' && <NumberField {...commonProps} />}
              {field.type === 'select' && <SelectField {...commonProps} />}
              {field.type === 'checkbox' && <CheckboxField {...commonProps} />}
              {field.type === 'textarea' && <TextareaField {...commonProps} />}
              {field.type === 'radio' && <RadioField {...commonProps} />}
              {field.type === 'date' && <DateField {...commonProps} />}
              {field.type === 'switch' && <SwitchField {...commonProps} />}
              {field.type === 'password' && <PasswordField {...commonProps} />}
              {field.type === 'file' && <FileUploadField {...commonProps} />}
            </Col>
          );
        })}
    </Row>
  );
};
